export const apiurl = {
    'branch-scheme-error': '/scheme-planning/ims/error/excel',
    'specific-modal-product-scheme-error': '/scheme-planning/ims/error/file',
    'ims-scheme-order-invoice-pdf': '/scheme-planning/ims/preview/pdf'
};
